import administracion from './administracion';
import terceros from './terceros';

// types
import { NavItemType } from 'types/menu';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [terceros, administracion]
};

export default menuItems;
